import {$, HttpBody, ID, Resource, ResponseSerialize} from 'simpli-web-sdk'
import CalendarizacaoSlaSchema from '@/schema/CalendarizacaoSla.schema.ts'
import {Exclude} from 'class-transformer'

export default class CalendarizacaoSla extends Resource {

  @Exclude()
  readonly $name: string = 'CalendarizacaoSla'

  @Exclude()
  readonly $endpoint: string = ''

  get $schema() {
    return CalendarizacaoSlaSchema(this)
  }

  get $id() {
    return this.idConfigNovaSlaFk
  }
  set $id(val: ID) {
    this.idConfigNovaSlaFk = val
  }

  @Exclude()
  idConfigNovaSlaFk: ID = 0

  seg: boolean = false
  ter: boolean = false
  qua: boolean = false
  qui: boolean = false
  sex: boolean = false
  sab: boolean = false
  dom: boolean = false
}
